import { render, staticRenderFns } from "./medical_record_v2_family.vue?vue&type=template&id=28f3a6fa&scoped=true"
import script from "./medical_record_v2_family.vue?vue&type=script&lang=js"
export * from "./medical_record_v2_family.vue?vue&type=script&lang=js"
import style0 from "./medical_record_v2_family.vue?vue&type=style&index=0&id=28f3a6fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f3a6fa",
  null
  
)

export default component.exports